import React from 'react';

import { FontAwesomeIcon } from 'components/shared/Icon/FontAwesome';
import i18n from 'i18n';

import s from './index.module.css';

export const NoEvents = () => {
  return (
    <div className={s.noEvents}>
      <div className={s.icon}>
        <FontAwesomeIcon className="fa-sign-post fa-light" />
      </div>
      {i18n.t('proposal_content.event_details.no_events')}
    </div>
  );
};
